


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CommonSelect from "@/components/common/CommonSelect.vue";
import {AuthService} from "@/services/AuthService";
import {get} from "@/context/context";
import {Servers, urls} from "@/serverConfig";
import API from "@/utils/Api";

@Component({
  components: {
    CommonSelect
  },
})
export default class ServerSelect extends Vue {
  private api: API = get('api');
  private authService: AuthService = get('authService');

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop({default: 'servers'})
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: 'name'})
  private itemText!: string;

  @Prop({default: 'key'})
  private itemValue!: string;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('inputData')
  watchInputData() {
    this.$emit('input', this.inputData)
  }

  private inputData: string = '';
  private items: Array<any> = [];



  private async mounted() {
    Object.keys(urls).map(async (key: string) => {
      if (key != Servers.BACK) {
        this.items.push({key, name: key + ' Server'});
      }
    });
  }

  private handleChange(value: string) {
    const userToken:string|boolean = this.authService.getUserToken(value);
    this.api.changeServer(value);
    this.$emit('changeHost', value);
    this.$emit('changeServer', userToken);
  }

}
